import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const TestimonialsSection = ({ t }) => {
  return (
    <section id="testimonials" className="py-20 bg-stone-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.testimonials.title}
          </h2>
          <p className="text-xl text-orange-500 font-semibold">
            {t.testimonials.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {t.testimonials && t.testimonials.items && t.testimonials.items.length > 0 && (
            <>
              {t.testimonials.items[0] && (
                <Card className="bg-stone-800 border-orange-500/20 hover:border-orange-500/50 transition-all duration-300 hover:scale-105">
                  <CardContent className="p-8">
                    <Quote className="h-10 w-10 text-orange-500 mb-4 opacity-50" />
                    <div className="flex mb-4">
                      <Star className="h-5 w-5 text-orange-500 fill-current" />
                      <Star className="h-5 w-5 text-orange-500 fill-current" />
                      <Star className="h-5 w-5 text-orange-500 fill-current" />
                      <Star className="h-5 w-5 text-orange-500 fill-current" />
                      <Star className="h-5 w-5 text-orange-500 fill-current" />
                    </div>
                    <p className="text-gray-300 mb-6 leading-relaxed italic">"{t.testimonials.items[0].text}"</p>
                    <p className="text-orange-500 text-sm font-semibold mb-4">{t.testimonials.items[0].hunt}</p>
                    <div className="border-t border-orange-500/20 pt-4">
                      <p className="text-white font-semibold">{t.testimonials.items[0].name}</p>
                      <p className="text-gray-400 text-sm">{t.testimonials.items[0].location}</p>
                    </div>
                  </CardContent>
                </Card>
              )}
              
              {t.testimonials.items[1] && (
                <Card className="bg-stone-800 border-orange-500/20 hover:border-orange-500/50 transition-all duration-300 hover:scale-105">
                  <CardContent className="p-8">
                    <Quote className="h-10 w-10 text-orange-500 mb-4 opacity-50" />
                    <div className="flex mb-4">
                      <Star className="h-5 w-5 text-orange-500 fill-current" />
                      <Star className="h-5 w-5 text-orange-500 fill-current" />
                      <Star className="h-5 w-5 text-orange-500 fill-current" />
                      <Star className="h-5 w-5 text-orange-500 fill-current" />
                      <Star className="h-5 w-5 text-orange-500 fill-current" />
                    </div>
                    <p className="text-gray-300 mb-6 leading-relaxed italic">"{t.testimonials.items[1].text}"</p>
                    <p className="text-orange-500 text-sm font-semibold mb-4">{t.testimonials.items[1].hunt}</p>
                    <div className="border-t border-orange-500/20 pt-4">
                      <p className="text-white font-semibold">{t.testimonials.items[1].name}</p>
                      <p className="text-gray-400 text-sm">{t.testimonials.items[1].location}</p>
                    </div>
                  </CardContent>
                </Card>
              )}
              
              {t.testimonials.items[2] && (
                <Card className="bg-stone-800 border-orange-500/20 hover:border-orange-500/50 transition-all duration-300 hover:scale-105">
                  <CardContent className="p-8">
                    <Quote className="h-10 w-10 text-orange-500 mb-4 opacity-50" />
                    <div className="flex mb-4">
                      <Star className="h-5 w-5 text-orange-500 fill-current" />
                      <Star className="h-5 w-5 text-orange-500 fill-current" />
                      <Star className="h-5 w-5 text-orange-500 fill-current" />
                      <Star className="h-5 w-5 text-orange-500 fill-current" />
                      <Star className="h-5 w-5 text-orange-500 fill-current" />
                    </div>
                    <p className="text-gray-300 mb-6 leading-relaxed italic">"{t.testimonials.items[2].text}"</p>
                    <p className="text-orange-500 text-sm font-semibold mb-4">{t.testimonials.items[2].hunt}</p>
                    <div className="border-t border-orange-500/20 pt-4">
                      <p className="text-white font-semibold">{t.testimonials.items[2].name}</p>
                      <p className="text-gray-400 text-sm">{t.testimonials.items[2].location}</p>
                    </div>
                  </CardContent>
                </Card>
              )}
            </>
          )}
        </div>

        {/* Trust Badges */}
        <div className="mt-16 text-center">
          <p className="text-gray-400 text-lg mb-4">
            Pourvoirie certifiée et membre de:
          </p>
          <div className="flex flex-wrap justify-center gap-8 text-gray-500">
            <span className="font-semibold">Fédération des Pourvoiries du Québec</span>
            <span className="font-semibold">Association des Guides de Chasse</span>
            <span className="font-semibold">Tourisme Outaouais</span>
          </div>
        </div>
      </div>
    </section>
  );
};
